import { ProjectStore } from "@/store/model";
import { Store } from "vuex";

let $store: Store<ProjectStore>;

export function initializeStore(storeInstance: Store<ProjectStore>): void {
  $store = storeInstance;
}

export { $store };
